function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bx-test-tube",
  d: "M19.939,4.06l1.227,1.227L4.977,21.477a6.75,6.75,0,0,0,9.546,9.546l16.19-16.19L31.94,16.06l2.121-2.121-12-12L19.94,4.06Zm4.773,12.531-3.6-3.606-2.121,2.121,3.6,3.606L20.47,20.835,18.985,19.35l-2.121,2.121,1.485,1.485-2.123,2.123-3.6-3.606L10.5,23.592,14.1,27.2l-1.7,1.7a3.841,3.841,0,0,1-5.3,0,3.753,3.753,0,0,1,0-5.3L23.288,7.409l5.3,5.3-3.877,3.881Z",
  transform: "translate(-3 -1.939)",
  fill: "#ac1ede"
});

var SvgBxTestTube = function SvgBxTestTube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.061,
    height: 31.061,
    viewBox: "0 0 31.061 31.061",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxTestTube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bx-test-tube.8cd86f7e.svg";
export { ForwardRef as ReactComponent };